import { Theme } from '@mui/material/styles'

const useStyles = {
  container: (theme: Theme) => ({
    backgroundColor: theme.palette.background.paper,
    borderColor: theme.palette.background.paper,
    borderWidth: '1px',
    borderStyle: 'solid',
    alignItems: 'center',
    borderRadius: 0.5,
    paddingX: 2,
    paddingY: 1.5,
    gap: 1.5,
  }),
  pausedContainer: {
    backgroundColor: '#e8f7f0',
    borderColor: '#BFECD7',
  },
  textContent: {
    flex: '1',
  },
}
export default useStyles
